import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import { PostPpiCardInfoResponse } from "@appetize/iw-common/interfaces/ppi/ppi-dto";
import { PostPpiCardInfoRequestPayload } from "@appetize/iw-common/interfaces/ppi/internalRequest";
import { CheckoutRequestBody } from "@appetize/iw-common/interfaces/checkout/internalRequest";

const http: AxiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

export const cardInfo = (
  accountId: string,
  paymentType: string,
  subpaymentType: string,
  payload: PostPpiCardInfoRequestPayload
): Promise<AxiosResponse<PostPpiCardInfoResponse>> => {
  return http.post("/ppi/cardInfo", { accountId, paymentType, subpaymentType, payload }, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
};

export const checkout = (venueId: string, vendorId: string, payload: CheckoutRequestBody): Promise<AxiosResponse<any>> => {
  return http.post(`/venues/${venueId}/vendors/${vendorId}/checkout`, payload, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
};

export default {
  cardInfo,
  checkout
};
